import React, { useState } from 'react';
import './ChatInput.css';

function ChatInput({ onSendMessage, disabled }) {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !disabled) {
      onSendMessage(inputValue.trim());
      setInputValue('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form className="chat-input-container" onSubmit={handleSubmit}>
      <div className="chat-input-wrapper">
        <div className="input-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 4H4C2.93913 4 1.92178 4.42143 1.17157 5.17157C0.421427 5.92178 0 6.93913 0 8V16C0 17.0609 0.421427 18.0782 1.17157 18.8284C1.92178 19.5786 2.93913 20 4 20H20C21.0609 20 22.0782 19.5786 22.8284 18.8284C23.5786 18.0782 24 17.0609 24 16V8C24 6.93913 23.5786 5.92178 22.8284 5.17157C22.0782 4.42143 21.0609 4 20 4H13M11 4L13 6M11 4L13 2M13 6L15 8M13 2L15 4M15 8L17 10M15 4L17 6M17 10L19 12M17 6L19 8M19 12L21 14M19 8L21 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <input
          type="text"
          className="chat-input"
          placeholder="Chat..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
        />
        <button
          type="submit"
          className="send-button"
          disabled={disabled || !inputValue.trim()}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </form>
  );
}

export default ChatInput;

